import { useCallback, useState } from 'react';

import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import type { TextFieldProps } from '@mui/material/TextField';

type Props = Omit<TextFieldProps, 'type' | 'autoComplete'> &
  Readonly<{
    // A password manager fills a current password and generates a new one.
    autoComplete: 'current-password' | 'new-password';
  }>;

export const PasswordField = (props: Readonly<Props>) => {
  const [isShown, setIsShown] = useState(false);

  const toggle = useCallback(() => {
    setIsShown((shown) => !shown);
  }, []);

  return (
    <TextField
      // A wrapper of TextField: every TextField prop goes through.
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      slotProps={{
        input: {
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label={
                  isShown
                    ? 'Masquer le mot de passe'
                    : 'Afficher le mot de passe'
                }
                edge="end"
                onClick={toggle}
              >
                {isShown ? <VisibilityOffIcon /> : <VisibilityIcon />}
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
      type={isShown ? 'text' : 'password'}
    />
  );
};
